import {
  FlowModuleItemType,
  ModuleInputKeyEnum,
} from "@packages/flow-core/module";
import NodeCard from "../NodeCard";
import { NodeProps } from "reactflow";
import Divider from "../Divider";
import RenderInput from "../render/RenderInput";
import styles from "./index.less";
import { RenderInputProps } from "../render/RenderInput/types";
import { InputNumber, Select, Space } from "antd";
import { useFlow } from "../FlowEdit/useFlow";
import { memo, useEffect, useMemo } from "react";
import RenderOutput from "../render/RenderOutput";

const TfJudgeConditionNum = memo(({ moduleId, item }: RenderInputProps) => {
  const { key } = item;
  const value = (item.value || {}) as { op: string; right: number };
  const { updateNodeValue, getNode } = useFlow();

  const curNode = getNode(moduleId, item.key);

  return (
    <Space.Compact style={{ width: "100%" }}>
      <Select
        style={{ width: 60 }}
        options={item.list}
        defaultValue={value.op}
        onChange={(v) => {
          updateNodeValue(moduleId, key, {
            ...(curNode?.value || {}),
            op: v,
          });
        }}
      />
      <InputNumber
        value={value.right}
        onBlur={(e) =>
          updateNodeValue(moduleId, key, {
            ...(curNode?.value || {}),
            right: e.target.value && Number(e.target.value),
          })
        }
        style={{ width: "100%" }}
      />
    </Space.Compact>
  );
});

const TfJudgeCondition = ({ moduleId, item }: RenderInputProps) => {
  const mode = item.value as string;
  const { updateNodeValue } = useFlow();

  return (
    <Select
      options={item.list}
      defaultValue={mode}
      placeholder={item.placeholder}
      onChange={(v) => {
        updateNodeValue(moduleId, item.key, v);
      }}
      style={{ width: "100%" }}
      className={styles["mb-24"]}
    />
  );
};

export default memo(function NodeTFJudge({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { inputs, moduleId, outputs } = data;
  const { splitToolInputs, updateModuleInput } = useFlow();
  const { commonInputs } = splitToolInputs(inputs, moduleId);

  const mode = inputs.find(
    (item) => item.key === ModuleInputKeyEnum.tfJudgeMode
  )?.value;

  const opNumInput = useMemo(() => {
    return inputs!.find(
      (item) => item.key === ModuleInputKeyEnum.tfJudgeOpNum
    )!;
  }, [inputs]);

  const patternInput = useMemo(() => {
    return inputs!.find(
      (item) => item.key === ModuleInputKeyEnum.tfJudgePattern
    )!;
  }, [inputs]);

  useEffect(() => {
    if (mode === "pattern") {
      updateModuleInput(moduleId, opNumInput!.key, {
        ...opNumInput!,
        required: false,
        type: "hidden",
      });
      updateModuleInput(moduleId, patternInput!.key, {
        ...patternInput!,
        required: true,
        type: "textarea",
      });
    } else {
      updateModuleInput(moduleId, opNumInput!.key, {
        ...opNumInput!,
        required: true,
        type: "custom",
      });
      updateModuleInput(moduleId, patternInput!.key, {
        ...patternInput!,
        required: false,
        type: "hidden",
      });
    }
  }, [mode]);

  return (
    <NodeCard {...data} selected={selected}>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderInput
          moduleId={moduleId}
          flowInputList={commonInputs}
          CustomComponent={{
            [ModuleInputKeyEnum.tfJudgeMode]: TfJudgeCondition,
            [ModuleInputKeyEnum.tfJudgeOpNum]: TfJudgeConditionNum,
          }}
        />
      </div>
      <Divider text="输出" />
      <div className={styles.content}>
        <RenderOutput flowOutputList={outputs} moduleId={moduleId} />
      </div>
    </NodeCard>
  );
});
